import React, {Component} from 'react';
import RouterComponent from './Components/CommonControlls/RouterComponent';
import {Provider as AlertProvider} from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'
import Alert from './Components/CommonControlls/AlertComponent'
import {connect} from 'react-redux'
import LoadingOverlay from 'react-loading-overlay';
import './assets/css/style.css';
import './assets/css/custom.css';
import {SyncConfig} from './Components/OfflineDb/ConfigDataSync'
import {SelectSettings} from './Components/OfflineDb/IndexDbTranscSP'
import {db} from './db';

  
const mapStateToProps = (Store) => {
    return Store
}

const mapDispatchToProps = (dispatch) => {
    return {
        UpdateConfiguration: (data, type) => {
            dispatch({type: type, payload: {data}})
        },
    }
}

class App extends Component {
    constructor(props) {
        super(props);

    }

    render() {

        const alertoptions = {
            position: 'top center',
            timeout: 4000,
            offset: '30px',
            transition: 'scale',
            type: 'info',
            // type: this.props.ShowAlert.Type == 0 ? 'error' : this.props.ShowAlert.Type == 1 ? 'success' : 'info',
            marginBottom: '40px',
        }

        return (

            <div>

                <AlertProvider class="alertdiv" template={AlertTemplate} {...alertoptions}><Alert
                    alertmsg={this.props.ShowAlert.Msg}/></AlertProvider>

                <LoadingOverlay active={this.props.ShowLoader.IsLoading} spinner
                                styles={{overlay: (base) => ({...base, background: 'rgba(0,0,0,0.15)'})}}>
                    <RouterComponent/>
                </LoadingOverlay>

            </div>

        )
    }

    componentDidMount() {

        if (localStorage.DBVersion === undefined || localStorage.DBVersion !== "V3.8") {
            db.delete();
            // db.Roles.clear();db.Riders.clear();db.Province.clear();db.District.clear();
            // db.Tehsil.clear();db.XpertSite.clear();db.HCF.clear();db.Settings.clear();
            // db.Patients.clear();db.PatientSamples.clear();db.LoggedInUser.clear();db.ActivityLog.clear();
            localStorage.DBVersion = "V3.8"
        }

        if (this.props.UserAuthentication.AuthToken !== "") {
            setInterval(() => {
                SyncConfig(() => {
                    console.log("success")
                    this.UpdateConfigurationStore()
                }, () => {
                    console.log("error")
                })
            }, 60000);    //1 minute
        }
    }

    UpdateConfigurationStore = () => {
        SelectSettings((data) => {
            this.props.UpdateConfiguration(data, "UpdateSystemSetting")
        }, (error) => {
        })

    }

}


export default connect(mapStateToProps, mapDispatchToProps)(App);


